import { Injectable } from '@angular/core';
import {urlErpApi} from '../../../../utils/apiConfig';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  constructor(private http: HttpClient) { }


  getAllAgendas(): Observable<any>{
    return this.http.get(`${urlErpApi}/app/schedules/list`, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}});
  }

  createAgenda(objectCreate: any): Observable<any>{
    return this.http.post(`${urlErpApi}/app/schedules/create`, objectCreate,  {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}});
  }

  getTimesAgenda(scheduleId: string, day: string): Observable<any>{
    return this.http.get(`${urlErpApi}/app/schedules/list/times/${scheduleId}/${day}`, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}});
  }

  updateAppointment(objectData: any): Observable<any>{
    console.log("Enviando o objeto: ",objectData);
    return this.http.put(`${urlErpApi}/app/appointments/update`, objectData, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}})
  }

  createAppointment(objectData: any): Observable<any>{
    return this.http.post(`${urlErpApi}/app/appointments/create`, objectData, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}});
  }

  createAppointmentReeschedule(objectData: any): Observable<any>{
    return this.http.post(`${urlErpApi}/app/appointments/create-reeschedule`, objectData, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}});
  }

  createAppointmentFitting(objectData: any): Observable<any>{
    return this.http.post(`${urlErpApi}/app/appointments/create-fitting`, objectData, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}});
  }

  updateSchedule(objectData: any): Observable<any> { 
    return this.http.put(`${urlErpApi}/app/schedules/update`, objectData, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}})
  }

  deleteSchedule(scheduleId: string): Observable<any>{
    return this.http.delete(`${urlErpApi}/app/schedules/delete/${scheduleId}`, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}})
  }
 
  getAvaliableTimes(date: string, scheduleId: string): Observable<any>{
     return this.http.get(`${urlErpApi}/app/schedules/list/times/available/${scheduleId}/${date}`, {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') ?? '' }});
  }

} 
